import { NAVIGATION_STEP } from "./actions";
import { RESET_APPS } from "@store/actions";

// Initialize Sidebar state
const initialSidebarState = {
  stepsMeta: {
    activeStep: 0,
    activeSubStep: 0
  }
};

const sidebarReducer = (state = initialSidebarState, action) => {
  switch (action.type) {
    // Update the step metadata
    case NAVIGATION_STEP:
      return { ...state, stepsMeta: action.newStepsMeta };
    // Reset the app by returning the initial state
    case RESET_APPS:
      return initialSidebarState;
    default:
      return state;
  }
};

export default sidebarReducer;



// WEBPACK FOOTER //
// ./src/workerhome/components/Sidebar/reducer.js